import { FunnelIcon } from "@heroicons/react/24/outline";
import { FunnelIcon as FunnelIconSolid } from "@heroicons/react/24/solid";
import clsx from "clsx";
import { useSpotlitControl } from "@/contexts/WidgetSpotlightContext";

export interface FilterPanelToggleProps {
  /** Whether the panel is currently open */
  isOpen: boolean;
  /** Whether there are any active filter selections */
  hasSelections: boolean;
  /** Toggle callback */
  onToggle: () => void;
  /** Optional custom icon */
  icon?: React.ReactNode;
  /** Optional tooltip/title */
  title?: string;
}

export default function FilterPanelToggle({
  isOpen,
  hasSelections,
  onToggle,
  icon,
  title = "Filter options",
}: FilterPanelToggleProps) {
  // Null everywhere except inside the widget the guided demo is pointing at,
  // and null always in popout windows (the provider is main-window only).
  const glow = useSpotlitControl() === "filter" && !isOpen;

  return (
    <button
      onClick={onToggle}
      className={clsx(
        "p-1 no-drag transition-all duration-200",
        glow && "nq-demo-pulse",
        // Menu open = solid fill
        isOpen && "bg-squawk-blue",
        // Active + closed = subtle indicator
        hasSelections && !isOpen && "bg-transparent",
        // Default = neutral
        !hasSelections &&
          !isOpen &&
          "bg-transparent hover:bg-gray-200 dark:hover:bg-gray-600"
      )}
      title={isOpen ? "Close filters" : title}
    >
      {icon != null ? (
        icon
      ) : hasSelections && !isOpen ? (
        <FunnelIconSolid className="size-4 text-squawk-blue" />
      ) : (
        <FunnelIcon
          className={clsx("size-4", {
            "text-white": isOpen,
            "text-gray-500 dark:text-gray-300": !isOpen,
          })}
        />
      )}
    </button>
  );
}
